<div class="row">
  @if (props.label) {
    <label
      class="col-md-6 form-label d-flex justify-content-between align-items-center {{ labelIndentCssClass }}"
      [attr.for]="id"
      [attr.role]="props.group ? 'presentation' : null"
    >
      @if (!props.abbr) {
        <span>
          {{ props.label }}
        </span>
      }
      @if (props.abbr) {
        <abbr title="{{ props.abbr }}">
          {{ props.label }}
        </abbr>
      }
    </label>
  }
  <div
    class="col-md-6"
    [attr.role]="props.group ? 'group' : null"
    [attr.aria-labelledby]="id + key.toString()"
  >
    <div
      class="sr-only"
      [id]="id + key.toString()"
    >
      {{ props.label }}
    </div>

    <ng-template #fieldComponent />
  </div>
</div>
